<template>
  <div>
    <wx-open-launch-weapp
        id="launch-btn"
        username="gh_ecbecd97e174"
        path="pages/home/index"
    >
      <script type="text/wxtag-template">
        @import '@/assets/styles/weui.css';这个分号一定要写，要不会报错
        <style>
          .weui-btn_primary {
            background-color: #07c160;
          }

          .weui-btn {
            position: relative;
            display: block;
            width: 184px;
            margin-left: auto;
            margin-right: auto;
            padding: 8px 24px;
            box-sizing: border-box;
            font-weight: 700;
            font-size: 17px;
            text-align: center;
            text-decoration: none;
            color: #fff;
            line-height: 1.88235294;
            border-radius: 8px;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            -webkit-user-select: none;
            user-select: none;
          }

        </style>
        <div class="weui_msg" style="padding-top: 20vh;">
          <div class="weui_icon_area"><i class="weui_icon_msg weui_icon_success"></i></div>
          <div class="weui_text_area">
            <h4 class="weui_msg_title">打开小程序</h4>
          </div>
        </div>
      </script>
    </wx-open-launch-weapp>
  </div>
</template>

<script>
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'ToWeApp',
  data() {
    return {}
  },
  created() {
    wxCloseShare()
  },
  methods: {},
}
</script>
<style>


</style>
